import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { clearAllUserData } from '../services/clearDataService';

const ClearDataButton = ({ onDataCleared }) => {
  const { currentUser } = useAuth();
  const [isClearing, setIsClearing] = useState(false);

  const handleClearData = async () => {
    if (!currentUser) {
      alert('You must be logged in to clear data');
      return;
    }

    setIsClearing(true);
    
    try {
      const results = await clearAllUserData(currentUser.uid);
      
      // Show success message with details
      const message = `Successfully cleared:
- ${results.acceptedEvents} accepted events
- ${results.pendingEvents} pending events  
- ${results.emails} emails
- ${results.tldrs} TLDRs`;
      
      alert(message);
      
      // Call callback to refresh the UI
      if (onDataCleared) {
        onDataCleared();
      }
    } catch (error) {
      console.error('Error clearing data:', error);
      alert('Failed to clear data: ' + error.message);
    } finally {
      setIsClearing(false);
    }
  };

  return (
    <>
      <button
        onClick={handleClearData}
        disabled={isClearing}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          width: '100%',
          padding: '0',
          backgroundColor: 'transparent',
          color: isClearing ? '#aaa' : '#dc3545',
          border: 'none',
          fontSize: '0.95rem',
          fontWeight: '500',
          cursor: isClearing ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.2s ease',
          textAlign: 'left',
        }}
        onMouseEnter={(e) => {
          if (!isClearing) {
            e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        {isClearing ? (
          <>
            <div style={{
              width: '18px',
              height: '18px',
              border: '2px solid #dc3545',
              borderTopColor: 'transparent',
              borderRadius: '50%',
              animation: 'spin 0.6s linear infinite',
            }} />
            Clearing...
          </>
        ) : (
          <>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
            Clear All Data
          </>
        )}
      </button>
      
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `
      }} />
    </>
  );
};

export default ClearDataButton;